//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Section.js";
let d=[[[1,"CappingFaces",0,"ScCollector",0],[0,"CombineRibWithTarget",1,0],[1,"DraftAngle",0,"Expression",0],[0,"ReverseOffsetDirection",1,0],[0,"ReverseRibDirection",1,0],[0,"ReverseThicknessDirection",1,0],[0,"RibCapGeometryOption",1,0],[1,"RibCapOffset",0,"Expression",0],[0,"RibDraftOption",1,0],[1,"RibThickness",0,"Expression",0],[0,"RibThicknessOffsetOption",1,0],[0,"RibType",1,0],[1,"Section",0,"Section",0],[1,"TargetBody",0,"ScCollector",0]],[],[]];
SPLM.Features.RibBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.RibBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.RibBuilder.RibTypes = Object.freeze({
    "PerpendiculartoSectionPlane" : "PerpendiculartoSectionPlane", "ParalleltoSectionPlane" : "ParalleltoSectionPlane"});

SPLM.Features.RibBuilder.RibThicknessOffsetOptions = Object.freeze({
    "Symmetric" : "Symmetric", "Asymmetric" : "Asymmetric"});

SPLM.Features.RibBuilder.RibCapGeometryOptions = Object.freeze({
    "FromSection" : "FromSection", "FromSelected" : "FromSelected"});

SPLM.Features.RibBuilder.RibDraftOptions = Object.freeze({
    "None" : "None", "FromCap" : "FromCap"});

export default SPLM;